import CryptoJS from "crypto-js";
// 随机生成指定数量的16进制key
export function generatekey(num) {
    const library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let key = "";
    for (let i = 0; i < num; i++) {
        const randomPoz = Math.floor(Math.random() * library.length);
        key += library.substring(randomPoz, randomPoz + 1);
    }
    return key;
}

// 加密
export function encrypt(word, keyStr) {
    if (keyStr.length < 16) {
        for (let i = 16 - keyStr.length; i > 0; i--) {
            keyStr += "X";
        }
    }
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
}

// 解密
export function decrypt(word, keyStr) {
    if (keyStr.length < 16) {
        for (let i = 16 - keyStr.length; i > 0; i--) {
            keyStr += "X";
        }
    }
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
